export default {
  name: "human",
  data() {
    return {};
  }
};